// Case-insensitive multi-field job filter, shared by every job picker
// in the app (Time Tracker's Add/Edit entry dialog, JobSelectionCard
// used by PreCon/Soft Dig/Locate/CSE/Check-In/Check-Out/Pre-Trip).
// Field workers complain about scrolling 100+ jobs to find the one
// they need; this lets them type any keyword — customer name,
// address, job number, or words from the title — and narrow the list
// instantly.
export const filterJobsByQuery = (allJobsList, query) => {
  if (!query || !query.trim()) return allJobsList;
  const q = query.trim().toLowerCase();
  // Allow space-separated tokens — ALL must match somewhere in the
  // searchable string. So "transcore 26156" finds the right job even
  // if those tokens appear in different fields.
  const tokens = q.split(/\s+/).filter(Boolean);
  return (allJobsList || []).filter((j) => {
    const hay = [
      j.job_number,
      j.job_title,
      j.client_name,
      j.contact_name,
      j.service_address,
      j.service_city,
      j.service_state,
      j.service_type,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return tokens.every((t) => hay.includes(t));
  });
};
